const translation = {
  nav: {
    home: "Home",
    categories: "Categorie",
    guide: "Guida",
    blog: "Blog",
    faq: "FAQ",
    shoppingGuide: "Guida Acquisti",
  },
  hero: {
    title: "Itaobuy Spreadsheet",
    subtitle: "La guida italiana completa per scoprire, confrontare e utilizzare al meglio gli strumenti spreadsheet più avanzati. Dalla gestione dati alla produttività digitale, tutto ciò che ti serve sapere.",
    cta_primary: "Itaobuy Sheet",
    cta_secondary: "Buy It Now",
    badge_1: "Guide Dettagliate",
    badge_2: "Confronti Professionali",
    badge_3: "Sicurezza Garantita",
  },
  categories: {
    title: "Esplora le Categorie",
    subtitle: "Scopri la nostra selezione completa di prodotti. Clicca su qualsiasi categoria per esplorare il catalogo completo su Itaobuy Sheet.",
    shoes: "Scarpe",
    hoodies: "Felpe/Maglioni",
    tshirts: "T-Shirt",
    jackets: "Giacche",
    pants: "Pantaloni/Corti",
    headwear: "Cappelli",
    sets: "Set Completi",
    underwear: "Intimo/Slip",
    jersey: "Maglie Sportive",
    accessories: "Accessori",
    bags: "Borse",
    belts: "Cinture",
    perfumes: "Profumi",
    other: "Altro",
  },
  seoArticles: {
    title: "Articoli e Guide SEO",
    subtitle: "Approfondisci la tua conoscenza di Itaobuy Spreadsheet con la nostra raccolta di guide dettagliate, tutorial pratici e analisi approfondite.",
    readMore: "Leggi l'Articolo",
    articles: {
      guida: {
        title: "Guida Completa Itaobuy Spreadsheet",
        excerpt: "Tutto ciò che devi sapere su Itaobuy Spreadsheet: funzionalità, configurazione iniziale, automazioni e best practice per la produttività.",
        category: "Guida",
      },
      tutorial: {
        title: "Tutorial Itaobuy Spreadsheet per Principianti",
        excerpt: "Un percorso passo dopo passo per imparare a utilizzare Itaobuy Spreadsheet da zero. Dalle basi alle funzionalità intermedie in pochi minuti.",
        category: "Tutorial",
      },
      sicurezza: {
        title: "Sicurezza Itaobuy Spreadsheet: Analisi Completa",
        excerpt: "Analizziamo nel dettaglio i protocolli di sicurezza, la crittografia dei dati e le politiche di privacy di Itaobuy Spreadsheet.",
        category: "Sicurezza",
      },
      template: {
        title: "Migliori Template per Itaobuy Spreadsheet",
        excerpt: "Scopri la nostra selezione dei template più utili per budget, gestione progetti, analisi dati e molto altro su Itaobuy Spreadsheet.",
        category: "Template",
      },
      alternative: {
        title: "Alternative a Itaobuy Spreadsheet nel 2026",
        excerpt: "Un confronto approfondito con le migliori alternative: Excel, Google Sheets, Airtable e altri strumenti spreadsheet a confronto.",
        category: "Alternative",
      },
      comeFunziona: {
        title: "Come Funziona Itaobuy Spreadsheet",
        excerpt: "Spieghiamo il funzionamento completo della piattaforma: dall'interfaccia utente alle automazioni avanzate, tutto spiegato in modo chiaro.",
        category: "Guida",
      },
      recensione: {
        title: "Recensione Itaobuy Spreadsheet 2026",
        excerpt: "La nostra recensione onesta e dettagliata: pro, contro, opinioni degli utenti e valutazione complessiva dello strumento.",
        category: "Recensione",
      },
      confronto: {
        title: "Itaobuy Spreadsheet vs Excel vs Google Sheets",
        excerpt: "Confronto testa a testa tra i tre giganti degli spreadsheet: funzionalità, prezzi, facilità d'uso e molto altro ancora.",
        category: "Confronto",
      },
      opinioni: {
        title: "Opinioni e Recensioni Itaobuy Spreadsheet",
        excerpt: "Raccogliamo le opinioni reali degli utenti italiani su Itaobuy Spreadsheet: esperienze, vantaggi e critiche costruttive.",
        category: "Opinioni",
      },
    },
  },
  whatIs: {
    title: "Cos'è Itaobuy Spreadsheet?",
    description: "Itaobuy Spreadsheet è una piattaforma innovativa dedicata alla gestione intelligente dei dati e all'organizzazione delle informazioni digitali. Con un'interfaccia intuitiva e strumenti avanzati, permette di creare tabelle professionali, gestire grandi volumi di dati e migliorare significativamente la produttività quotidiana. Che tu sia uno studente, un professionista o un imprenditore, Itaobuy Spreadsheet offre soluzioni su misura per ogni esigenza.",
    features: {
      data: "Gestione Dati",
      data_desc: "Organizzazione semplice e intuitiva dei tuoi dati",
      templates: "Template",
      templates_desc: "Modelli professionali pronti all'uso",
      collab: "Collaborazione",
      collab_desc: "Lavoro di squadra efficiente e sincronizzato",
      automation: "Automazione",
      automation_desc: "Riduci le attività manuali ripetitive",
      compatibility: "Compatibilità",
      compatibility_desc: "Utilizzo multipiattaforma senza limiti",
    },
  },
  whyChoose: {
    title: "Perché Scegliere Itaobuy Spreadsheet?",
    cards: {
      easy: {
        title: "Facile da Usare",
        desc: "Interfaccia intuitiva progettata per garantire un'esperienza fluida anche ai principianti. Nessuna curva di apprendimento ripida.",
      },
      professional: {
        title: "Gestione Professionale",
        desc: "Strumenti avanzati per l'analisi dei dati, la creazione di report e la visualizzazione delle informazioni in tempo reale.",
      },
      productivity: {
        title: "Massima Produttività",
        desc: "Automatizza i processi ripetitivi, risparmia ore di lavoro e concentrati su ciò che conta davvero per il tuo business.",
      },
      tools: {
        title: "Strumenti Avanzati",
        desc: "Dashboard personalizzabili, formule complesse, integrazioni API e molto altro per portare il tuo lavoro al livello successivo.",
      },
    },
  },
  comparison: {
    title: "Itaobuy Spreadsheet vs Alternative",
    subtitle: "Confronta le funzionalità principali e scopri perché Itaobuy Spreadsheet è la scelta migliore per le tue esigenze.",
    feature: "Funzionalità",
    itaobuy: "Itaobuy",
    excel: "Excel",
    googleSheets: "Google Sheets",
    rows: {
      ease: "Facilità d'uso",
      ease_itaobuy: "Alta",
      ease_excel: "Media",
      ease_gsheets: "Alta",
      collab: "Collaborazione",
      collab_itaobuy: "Alta",
      collab_excel: "Media",
      collab_gsheets: "Alta",
      cloud: "Cloud Integrato",
      cloud_itaobuy: "Incluso",
      cloud_excel: "Parziale",
      cloud_gsheets: "Incluso",
      automation: "Automazioni",
      automation_itaobuy: "Avanzate",
      automation_excel: "Avanzate",
      automation_gsheets: "Medie",
      online: "Utilizzo Online",
      online_itaobuy: "Completo",
      online_excel: "Limitato",
      online_gsheets: "Completo",
    },
  },
  security: {
    title: "Sicurezza e Affidabilità",
    description: "La protezione dei tuoi dati è la nostra priorità assoluta. Itaobuy Spreadsheet implementa i più elevati standard di sicurezza per garantire che le tue informazioni rimangano sempre protette e accessibili solo a te.",
    points: {
      encryption: "Crittografia end-to-end dei dati",
      privacy: "Politiche di privacy trasparenti e conformi al GDPR",
      access: "Controllo granulare degli accessi utente",
      backup: "Backup automatico e ripristino dei dati",
      compliance: "Conformità agli standard internazionali di sicurezza",
    },
    cta: "Scopri di più sulla sicurezza",
  },
  faq: {
    title: "Domande Frequenti",
    q1: "Cos'è esattamente Itaobuy Spreadsheet?",
    a1: "Itaobuy Spreadsheet è una piattaforma completa per la gestione e l'analisi dei dati tramite fogli di calcolo avanzati. Offre strumenti professionali per creare, modificare e condividere spreadsheet in cloud, con funzionalità di automazione, template predefiniti e integrazioni con altre applicazioni. È pensato sia per utenti principianti che per professionisti esperti che necessitano di uno strumento potente e flessibile.",
    q2: "Itaobuy Spreadsheet è gratuito?",
    a2: "Itaobuy Spreadsheet offre diverse opzioni di abbonamento per soddisfare ogni esigenza. È disponibile un piano base gratuito con funzionalità essenziali, perfetto per iniziare. Per utenti professionisti e aziende, sono disponibili piani premium con funzionalità avanzate come automazioni illimitate, storage maggiorato e supporto prioritario. Ti consigliamo di visitare il sito ufficiale per verificare i prezzi aggiornati.",
    q3: "È sicuro archiviare dati sensibili su Itaobuy Spreadsheet?",
    a3: "Assolutamente sì. Itaobuy Spreadsheet utilizza crittografia di livello bancario per proteggere tutti i dati in transito e a riposo. L'infrastruttura è conforme agli standard di sicurezza internazionali, con audit regolari e monitoraggio continuo. Inoltre, puoi configurare l'autenticazione a due fattori per un ulteriore livello di protezione del tuo account.",
    q4: "Posso collaborare con altre persone in tempo reale?",
    a4: "Sì, una delle funzionalità più apprezzate di Itaobuy Spreadsheet è la collaborazione in tempo reale. Puoi invitare colleghi o collaboratori a visualizzare o modificare i tuoi fogli di calcolo simultaneamente, con la possibilità di vedere le modifiche in tempo reale, aggiungere commenti e tenere traccia della cronologia delle versioni.",
    q5: "Itaobuy Spreadsheet funziona su dispositivi mobili?",
    a5: "Sì, Itaobuy Spreadsheet è completamente ottimizzato per dispositivi mobili. È disponibile un'app dedicata sia per iOS che per Android, che ti permette di accedere, modificare e condividere i tuoi spreadsheet ovunque ti trovi. L'interfaccia mobile è stata progettata per offrire un'esperienza fluida anche su schermi più piccoli.",
    q6: "Quali sono le principali alternative a Itaobuy Spreadsheet?",
    a6: "Le principali alternative includono Microsoft Excel, Google Sheets e Apple Numbers. Rispetto a queste, Itaobuy Spreadsheet si distingue per la combinazione unica di facilità d'uso, automazioni avanzate e integrazione cloud nativa. La scelta migliore dipende dalle tue esigenze specifiche: ti invitiamo a consultare la nostra tabella comparativa qui sopra per un confronto dettagliato.",
    q7: "Come posso importare dati da Excel o Google Sheets?",
    a7: "Itaobuy Spreadsheet supporta l'importazione diretta di file nei formati più comuni, inclusi .xlsx, .csv e .ods. Basta caricare il file e la piattaforma lo convertirà automaticamente, preservando formule, formattazione e struttura dei dati. Il processo è rapido e non richiede competenze tecniche particolari.",
    q8: "Esistono template predefiniti disponibili?",
    a8: "Sì, Itaobuy Spreadsheet mette a disposizione una vasta libreria di template professionali pronti all'uso. Troverai modelli per budget aziendali, gestione progetti, analisi finanziarie, report di marketing, pianificazione editoriale e molto altro. Tutti i template sono personalizzabili al 100%.",
    q9: "Serve una connessione internet per utilizzare Itaobuy Spreadsheet?",
    a9: "Per la maggior parte delle funzionalità è necessaria una connessione internet, poiché Itaobuy Spreadsheet è una piattaforma cloud-first. Tuttavia, è disponibile una modalità offline che ti permette di continuare a lavorare sui tuoi documenti anche senza connessione: tutte le modifiche verranno sincronizzate automaticamente quando tornerai online.",
    q10: "Come posso ottenere assistenza se ho problemi?",
    a10: "Itaobuy Spreadsheet offre diversi canali di assistenza: una knowledge base completa con guide e tutorial, un forum della community dove scambiare consigli con altri utenti, e un servizio di supporto via email con tempi di risposta rapidi. Gli abbonati ai piani premium hanno accesso al supporto prioritario con chat live.",
  },
  ctaSection: {
    title: "Pronto a Iniziare con Itaobuy Spreadsheet?",
    subtitle: "Unisciti a migliaia di utenti che hanno già migliorato la loro produttività. Scopri subito tutte le potenzialità di Itaobuy Spreadsheet.",
    button: "Vai a Itaobuy Sheet",
  },
  footer: {
    tagline: "Il portale italiano di riferimento per Itaobuy Spreadsheet. Guide, tutorial, confronti e tutto ciò che ti serve per padroneggiare gli strumenti spreadsheet più avanzati.",
    quickLinks: "Link Rapidi",
    categories: "Categorie",
    resources: "Risorse",
    copyright: "© 2026 Itaobuy Spreadsheet Italia. Tutti i diritti riservati.",
    privacy: "Privacy",
    terms: "Termini",
    contact: "Contatti",
    sitemap: "Mappa del Sito",
  },
  article: {
    readMore: "Leggi l'Articolo Completo",
    backHome: "Torna alla Home",
    category: "Guida",
    author: "Team Editoriale Itaobuy",
    date: "14 Luglio 2026",
    readingTime: "12 minuti di lettura",
  },
};

export default translation;